import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Constants/Config";

const formatReason = (raw) => {
  if (!raw || typeof raw !== "string") return "";
  return raw
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const formatTimestamp = (ts) => {
  if (!ts) return "";
  const d = new Date(ts.includes("T") || ts.includes("Z") ? ts : ts.replace(" ", "T") + "Z");
  if (isNaN(d.getTime())) return ts;
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const UberCancellationBanner = ({ order_id, merchant_id, token }) => {
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    if (!order_id || !merchant_id) return;
    let cancelled = false;

    const form = new FormData();
    form.append("order_id", order_id);
    form.append("merchant_id", merchant_id);

    axios
      .post(BASE_URL + "api/Uber_webhooks/get_resolution_protocol", form, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (!cancelled) setPayload(res?.data || null);
      })
      .catch(() => {
        if (!cancelled) setPayload(null);
      });

    return () => {
      cancelled = true;
    };
  }, [order_id, merchant_id, token]);

  if (!payload || payload.has_failure !== true) return null;

  const data = payload.data || {};
  const label = data.reason_source === "return" ? "Return reason:" : "Cancellation reason:";
  const formattedReason = formatReason(data.reason) || "Not provided by Uber";
  const entityLabel = data.reason_source === "return" ? "Returned by" : "Cancelled by";
  const timeLabel = data.reason_source === "return" ? "Returned at" : "Cancelled at";

  return (
    <div style={{ marginTop: "10px", fontSize: "0.9rem", color: "var(--qv-tx-444444, #444)", lineHeight: 1.6 }}>
      <div>
        <span style={{ fontWeight: 500 }}>{label}</span>{" "}
        <span style={{ color: "var(--qv-tx-b71c1c, #b71c1c)", fontWeight: 500 }}>{formattedReason}</span>
      </div>
      {(data.cancelled_by || data.failed_at) && (
        <div style={{ fontSize: "0.82rem", color: "var(--qv-tx-777777, #777)" }}>
          {data.cancelled_by && (
            <>
              {entityLabel}{" "}
              <span style={{ textTransform: "capitalize", color: "var(--qv-tx-555555, #555)" }}>{data.cancelled_by}</span>
            </>
          )}
          {data.cancelled_by && data.failed_at && " · "}
          {data.failed_at && (
            <>
              {timeLabel} <span style={{ color: "var(--qv-tx-555555, #555)" }}>{formatTimestamp(data.failed_at)}</span>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default UberCancellationBanner;
